import styles from './contactUs.module.scss';
import { BsQuestionCircleFill } from 'react-icons/bs';
import { useTranslations } from '../../contexts/LanguageContext'; 

function ContactUs() {
  const t = useTranslations();

  const contacts = [
    {
      name: "Ricardo Matthias", 
      email: "CDHS_TRAILS_NYTD@state.co.us",
      phone: "303-585-0288"
    }
  ];

  return (
    <section className={styles.mainContainer} aria-labelledby="contact-us-heading">
      <div className={styles.icon} aria-hidden="true">
        <BsQuestionCircleFill />
      </div>
      <h1 id="contact-us-heading">{t('contactUs_pageTitle', 'Contact Us')}</h1>
      <h2>{t('contactUs_surveyContactTitle', 'For questions about this survey contact:')}</h2>
      
      <ul className={styles.cardContainer}>
        {contacts.map((contact, index) => (
          <li key={index} className={styles.card}>
            <div className={styles.contactDetails}>
              {/* Conditionally render each piece of contact info */}
              {contact.name && <p className={styles.contactName}>{contact.name}</p>}
              {contact.email && (
                <p className={styles.contactEmail}>
                  <a href={`mailto:${contact.email}`}>{contact.email}</a>
                </p>
              )}
              {contact.phone && (
                <p className={styles.contactPhone}>
                  {/* Strip non-digits for the tel: link for better compatibility */}
                  <a href={`tel:${contact.phone.replace(/\D/g, '')}`}>{contact.phone}</a>
                </p>
              )}
            </div>
          </li>
        ))}
      </ul>
    </section> 
  );
}

export default ContactUs;